<template>
    <div>
      <header>
        <nav>
          <!-- Navigation links or other header content -->
          <ul>
            <li><router-link to="/dashboard">Dashboard</router-link></li>
            <li><router-link to="/tenantservices">Services</router-link></li>
          </ul>
        </nav>
      </header>

      <main>
        <router-view></router-view>
      </main>

      <footer>
        <!-- Footer content -->
        <p>&copy; 2024 Your Company. All rights reserved.</p>
      </footer>
    </div>
  </template>

  <script>
  export default {
    name: 'Layout'
  };
  </script>

  <style scoped>
  header {
    background-color: #333;
    color: #fff;
    padding: 10px 0;
  }

  header nav ul {
    list-style-type: none;
    padding: 0;
  }

  header nav ul li {
    display: inline;
    margin-right: 10px;
  }

  header nav ul li a {
    color: #fff;
    text-decoration: none;
  }

  main {
    padding: 20px;
  }

  footer {
    background-color: #333;
    color: #fff;
    text-align: center;
    padding: 10px 0;
    position: fixed;
    width: 100%;
    bottom: 0;
  }
  </style>
